module.exports = __webpack_public_path__ + "static/media/igor@3x.db5b2295.png";